/**
 * Snapshot Feature Icons
 *
 * Icons used by the Portable Health Snapshot screens and bottom sheets
 * (SnapshotsScreen, SnapshotIntroSheet, SnapshotInfoSheet, SnapshotShareSheet,
 * SnapshotPreviewSheet, AccountRecoveryCodeSheet, AccountRecoveryCodeEntrySheet).
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faLockKeyhole as fadLockKeyhole,
  faShareNodes as fadShareNodes,
  faRotateLeft as fadRotateLeft,
  faTriangleExclamation as fadTriangleExclamation,
  faEye as fadEye,
  faEyeSlash as fadEyeSlash,
  faShieldHalved as fadShieldHalved,
  faMobileSignalOut as fadMobileSignalOut,
  faBolt as fadBolt,
  faClipboardMedical as fadClipboardMedical,
  faPills as fadPills,
  faAddressBook as fadAddressBook,
  faFileMedical as fadFileMedical,
  faMobileSignal as fadMobileSignal,
  faBan as fadBan,
  faKey as fadKey,
  faKeySkeleton as fadKeySkeleton,
  faClipboard as fadClipboard,
  faWifiSlash as fadWifiSlash,
} from '@fortawesome/pro-duotone-svg-icons';

export const loadSnapshotIcons = () => {
  library.add(
    fadLockKeyhole,
    fadShareNodes,
    fadRotateLeft,
    fadTriangleExclamation,
    fadEye,
    fadEyeSlash,
    fadShieldHalved,
    fadMobileSignalOut,
    fadBolt,
    fadClipboardMedical,
    fadPills,
    fadAddressBook,
    fadFileMedical,
    fadMobileSignal,
    fadBan,
    fadKey,
    fadKeySkeleton,
    fadClipboard,
    fadWifiSlash,
  );
};
